import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import FilterAltIcon from "@mui/icons-material/FilterAlt";

const defaultOptions = [
  { value: "active", label: "Active questions" },
  { value: "archived", label: "Archived questions" },
  { value: "all", label: "All questions" },
];

function FilterMenu({ label, selectedValue, onChange, options }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const menuOptions = options?.length ? options : defaultOptions;
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value) => {
    if (value !== selectedValue) {
      onChange?.(value);
    }
    handleClose();
  };

  return (
    <>
      <Button
        id="question-filter-button"
        variant="contained"
        sx={{ background: "hsl(27.7, 100%, 62%)" }}
        aria-controls={open ? "question-filter-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={<FilterAltIcon />}
      >
        {label}
      </Button>
      <Menu
        id="question-filter-menu"
        aria-labelledby="question-filter-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {menuOptions.map((option) => (
          <MenuItem
            key={option.value}
            selected={selectedValue === option.value}
            onClick={() => handleSelect(option.value)}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

FilterMenu.propTypes = {
  label: PropTypes.string.isRequired,
  selectedValue: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
};

FilterMenu.defaultProps = {
  selectedValue: "active",
  onChange: undefined,
  options: undefined,
};

export default FilterMenu;
